<script lang="ts" setup>
import { ref } from "vue";
import { useMate } from "@/stores/mate";
const mateStore = useMate();
const showCreateTraitModal = ref(false);
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr_auto]">
    <!-- 顶部导航 -->
    <threads-nav :enable-switch-mate="false" :show-back="true">
      <template #right>
        <button
          class="btn btn-sm btn-primary rounded"
          @click="showCreateTraitModal = true"
        >
          {{ $t("trait.new") }}
        </button>
      </template>
    </threads-nav>
    <FeatureModule
      v-if="mateStore.currentMate"
      :mate-id="mateStore.currentMate!.id!"
      :show-create-btn="false"
    />
  </div>
  <CreateTraitPresetModal v-model:show="showCreateTraitModal" />
</template>
